const addToCartBarMixin = {
    mounted() {
        this.toggleAddToCartVisibility();
        window.addEventListener('scroll', this.toggleAddToCartVisibility, false);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.toggleAddToCartVisibility);
    },
    methods: {
        toggleAddToCartVisibility() {
            const elem = this.$el.querySelector('.price-start');
            const addToCartBar = document.querySelector('.add-to-cart-bar.buy-bar');

            if (!elem || !addToCartBar) return;

            const isOut = this.isOutOfViewport(elem);
            const method = isOut.any ? 'add' : 'remove';

            addToCartBar.classList[method]('show');
            document.body.classList[method]('add-to-cart-visible');
        },
        isOutOfViewport(elem) {
            const { top, left, bottom, right } = elem.getBoundingClientRect();
            const viewHeight = window.innerHeight || document.documentElement.clientHeight;
            const viewWidth = window.innerWidth || document.documentElement.clientWidth;

            return {
                top: top < 0,
                left: left < 0,
                bottom: bottom > viewHeight,
                right: right > viewWidth,
                get any() {
                    return this.top || this.left || this.bottom || this.right;
                }
            };
        },
    },
};
